
import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Pie } from 'react-chartjs-2';
import { Toast, ToastContainer } from "react-bootstrap";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import axios from "axios";
import { faChartLine,faTasks, faDownload, faBed, faEdit, faUsers, faBell} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Container, Col, Row, Form, Button,  Modal } from '@themesberg/react-bootstrap';
import Layout from '../../components/Layout';
import { CounterWidget, BarChartWidget, TeamMembersWidget, TotalRoomsWidget, CircleChartWidget, OccupancyCard } from "../../components/Widgets";
import { RoomAvailabilityTable } from "../../components/Tables";
import { BASE_URL } from "../../constants";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useAuth } from '../../Context/AuthContext';
//import { trafficShares, totalOrders } from "../../data/charts";
ChartJS.register(ArcElement, Tooltip, Legend);
export default () => {
  const [totalCourses, setTotalCourses] = useState(0);
  const [enrolledUsersCount, setEnrolledUsersCount] = useState(0);
  const [totalUsers, setTotalUsers] = useState(0); // Assuming total users can be fetched from another endpoint
  const [percentage, setPercentage] = useState(0);
  const [showModal, setShowModal] = useState(false);
const [notificationTitle, setNotificationTitle] = useState('');
const [notificationMessage, setNotificationMessage] = useState('');
const [showAlert, setShowAlert] = useState(false);
const [alertMessage, setAlertMessage] = useState('');
const [alertVariant, setAlertVariant] = useState('success'); 

  const { user } = useAuth();
  const navigate = useNavigate();
  const shelterId = user?.shelter.id;

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch total courses
        const coursesResponse = await axios.get(`${BASE_URL}/course`);
        setTotalCourses(coursesResponse.data.length); 

        // Fetch enrollments
        const enrollResponse = await axios.get(`${BASE_URL}/course/enrollments`);
        const enrollments = enrollResponse.data; 
       
        // Get unique enrolled users based on refugeeId
        const uniqueRefugees = new Set(enrollments.map((enroll) => enroll.refugeeId));
        setEnrolledUsersCount(uniqueRefugees.size);
     
        const totalUsersResponse = await axios.get(`${BASE_URL}/refugees`); 
        setTotalUsers(totalUsersResponse.data.length);
        const calculatedPercentage = totalUsersResponse.data.length
        ? ((uniqueRefugees.size / totalUsersResponse.data.length) * 100).toFixed(1)
        : 0;
      setPercentage(calculatedPercentage);
      } catch (error) {
        console.error("Error fetching course or enrollment data:", error);
      }
    };

    fetchData();
  }, []);
  const handleClick = () => {
    navigate('/admin/updateshelter'); 
  };
  const handleSendNotification = async () => {
    if (!notificationTitle || !notificationMessage) {
      setAlertMessage("Please fill in both fields.");
      setAlertVariant("danger");
      setShowAlert(true);
      return;
    }
    try {
      const token = localStorage.getItem("token");
      await axios.post(`${BASE_URL}/refugees/broadcast/${shelterId}`, {
        message: notificationMessage, 
        type: notificationTitle      
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  
    setAlertMessage("Notification sent successfully.");
    setAlertVariant("success");
    setShowAlert(true);
    setShowModal(false);
    setNotificationTitle('');
    setNotificationMessage('');
  } catch (error) {
    console.error("Error sending notification:", error);
    setAlertMessage("Failed to send notification.");
    setAlertVariant("danger");
    setShowAlert(true);
  }
};
  
  const handleExportRooms = async (shelterId) => {
    try {
      const response = await axios.get(`${BASE_URL}/accommodation/shelter/${shelterId}`);
      const rooms = response.data.rooms;
  
      if (!rooms || rooms.length === 0) {
        alert("No rooms found for this shelter.");
        return;
      }
  
      const csvHeader = ['Room Number', 'Capacity', 'Free Places', 'Occupied Places',  'Entry Dates','Exit Dates', 'Occupants'];
  
      const csvRows = rooms.map((room) => {
        const occupants = room.occupant || [];
  
        const occupantNames = occupants.map(
          (occ) => `${occ?.firstName || ''} ${occ?.lastName || ''}`
        ).join(' | '); // changed from '; '
  
        const entryDates = occupants.map(
          (occ) => occ?.entryDate ? new Date(occ.entryDate).toLocaleDateString() : ''
        ).join(' | '); // changed from '; '
    const exitDates = occupants.map(
          (occ) => occ?.exitDate ? new Date(occ.entryDate).toLocaleDateString() : ''
        ).join(' | ');
        return [
          room.roomNumber != null ? room.roomNumber : '',
          room.capacity != null ? room.capacity : '',
          room.freePlaces != null ? room.freePlaces : '',
          room.occupiedPlaces != null ? room.occupiedPlaces : '',
          entryDates,
          exitDates,
          occupantNames
        ];
        
      });
  
      const csvContent = [
        csvHeader,
        ...csvRows
      ].map(row => row.map(val => `"${val}"`).join(',')).join('\n');
  
      const blob = new Blob([csvContent], { type: 'text/csv' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `shelter_${shelterId}_rooms.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error exporting rooms:", error);
      alert("Failed to export rooms. Please try again later.");
    }
  };
  
  return (
    <Layout>
 <Container fluid className="px-3 py-4">
 <Row className="mb-4 gx-4 align-items-center">
  <Col xs={12} md={6}>
    <Button variant="cyan" onClick={handleClick}>
      <FontAwesomeIcon icon={faEdit} className="me-2" />
      <span className="small">Update shelter</span>
    </Button>
  </Col>

  <Col xs={12} md={6} className="text-md-end mt-2 mt-md-0">

    <Button variant="outline-cyan" className="me-2" onClick={() => setShowModal(true)}>
      <FontAwesomeIcon icon={faBell} className="me-2" />
      <span className="small">Send Notification</span>
    </Button>
    <Button
      variant="outline-cyan"
      onClick={() => handleExportRooms(shelterId)}
 
    >
      <FontAwesomeIcon icon={faDownload} className="me-2" />
      <span className="small">Export</span>
    </Button>

  </Col>
</Row>



  {/* Widgets row */}
  <Row className="g-4 mb-4">
    <Col xs={12} sm={6} lg={4}>
      <Link to="/admin/tasks" className="w-100 text-decoration-none">
        <CircleChartWidget
          title="Expired Tasks"
          icon={faTasks}
          iconColor="warning"
        />
      </Link>
    </Col>

    <Col xs={12} sm={6} lg={4}>
      <Link to="/admin/availability" className="w-100 text-decoration-none">
        <CounterWidget title="Not Available Users" icon={faUsers} />
      </Link>
    </Col>

    <Col xs={12} sm={12} lg={4}>
      <Link to="/admin/rooms" className="w-100 text-decoration-none">
        <TotalRoomsWidget title="Total Rooms" icon={faBed} iconColor="warning" />
      </Link>
    </Col>
  </Row>

  {/* Cards and table */}
  <Row className="g-4">
    <Col xs={12} md={6} lg={4}>
      <OccupancyCard />
    </Col>

    <Col xs={12} md={6} lg={8}>
      <RoomAvailabilityTable />
    </Col>
  </Row>
</Container>
<Modal show={showModal} onHide={() => setShowModal(false)} centered contentClassName="twitter-style-modal">
  <Modal.Body className="p-6 text-center bg-white rounded-4 shadow-lg">
    <div className="mb-4">
      <div
        className="bg-primary-subtle text-primary rounded-circle d-inline-flex align-items-center justify-content-center"
        style={{ width: 60, height: 60 }}
      >
        <i className="fas fa-bell fa-lg"></i>
      </div>
      <h5 className="fw-bold mt-3">Send Notification</h5>
    </div>

    <Form className="text-start">
      <Form.Group className="mb-3">
        <Form.Label className="fw-semibold">Title</Form.Label>
        <Form.Control
          type="text"
          placeholder="Notification title"
          className="rounded-3"
          value={notificationTitle}
          onChange={(e) => setNotificationTitle(e.target.value)}
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label className="fw-semibold">Message</Form.Label>
        <Form.Control
          as="textarea"
          rows={4}
          placeholder="Enter the notification content here..."
          className="rounded-3"
          value={notificationMessage}
          onChange={(e) => setNotificationMessage(e.target.value)}
        />
      </Form.Group>

      <Form.Group className="mb-4">
        <Form.Check
          type="checkbox"
          label="Select All Users"
          className="fw-medium"
          checked={true} // assuming always broadcast
          disabled // since the API already targets everyone
        />
      </Form.Group>
    </Form>

    <div className="d-grid gap-2">
      <Button
        variant="primary"
        className="rounded-pill fw-semibold py-2"
        onClick={handleSendNotification}
      >
        <i className="fas fa-paper-plane me-2"></i>Send Notification
      </Button>
      <Button
        variant="light"
        className="rounded-pill border fw-semibold py-2"
        onClick={() => setShowModal(false)}
      >
        Cancel
      </Button>
    </div>
  </Modal.Body>
</Modal>

<ToastContainer position="top-end" className="p-3">
  <Toast
    onClose={() => setShowAlert(false)}
    show={showAlert}
    delay={3000}
    autohide
    bg={alertVariant || "success"}
  >
    <Toast.Body className="text-white">{alertMessage}</Toast.Body>
  </Toast>
</ToastContainer>


  </Layout>
   
  );
};
